<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <img src="app_logo.svg" alt="leah Logo" class="login-logo">
      <p class="login-subtitle">Melden Sie sich an</p>
    </div>

    @if (errorMessage()) {
    <div class="login-error">
      {{ errorMessage() }}
    </div>
    }

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-field">
        <label for="email">E-Mail</label>
        <input id="email" type="email" pInputText formControlName="email" placeholder="E-Mail-Adresse eingeben" />
      </div>

      <div class="form-field">
        <label for="password">Passwort</label>
        <p-password id="password" formControlName="password" placeholder="Passwort eingeben" [feedback]="false"
          [toggleMask]="true" styleClass="w-full" inputStyleClass="w-full" />
      </div>

      <div class="form-actions">
        <p-button type="submit" label="Anmelden" [disabled]="form.invalid" [loading]="isLoading()"
          styleClass="w-full" />
      </div>

      <div class="form-links">
        <a routerLink="/auth/forgot-password">Passwort vergessen?</a>
      </div>
    </form>
  </div>
</div>